import { useEffect, useState, useCallback } from 'react';
import { isWindowExists } from '../utils';

export function useWindowDimensions() {
  const [dimensions, setDimensions] = useState({
    height: 0,
    width: 0
  });

  useEffect(() => {
    if (isWindowExists()) {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
  }, []);

  const handleResize = useCallback(() => {
    if (isWindowExists()) {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
  }, []);

  useEffect(() => {
    if (isWindowExists()) {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
    return undefined;
  }, [handleResize]);

  return { dimensions };
}
